import {api} from "../core/api";
import {handleHttp, IProps} from "../core/handleHttp";

const preAlias = "/v1/mensagem";

export const getMensagens = async () => {
    let req: IProps = {
        api: api,
        type: "get",
        url: `${preAlias}`
    }
    return await handleHttp(req)
}

export const salvarMensagem = async (body: any) => {
    let req: IProps = {
        api: api,
        type: "post",
        url: `${preAlias}`,
        body: body
    }
    return await handleHttp(req)
}

export const deletarMensagem = async (id: number) => {
    let req: IProps = {
        api: api,
        type: "delete",
        url: `${preAlias}/${id}`
    }
    return await handleHttp(req)
}

export const alternarFavoritoMensagem = async (id: number) => {
    let req: IProps = {
        api: api,
        type: "post",
        url: `${preAlias}/${id}/favorito`
    }
    return await handleHttp(req)
}

export const salvarOrdemFavoritos = async (ids: number[]) => {
    let req: IProps = {
        api: api,
        type: "put",
        url: `${preAlias}/favoritos/ordem`,
        body: ids
    }
    return await handleHttp(req)
}
